// filepath: src/pages/POSLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../hooks/useAuth";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Footer from "../components/CommonComponents/Footer";
import Lottie from "lottie-react";
import posMachineAnimation from "../assets/pos-machine.json";
import { getTenantLoginAccent } from "../constants/loginTheme";

export default function POSLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();
    const loginAccent = getTenantLoginAccent();

    const handleLogin = async () => {
        if (!username || !password) {
            toast.error("Please enter username and password");
            return;
        }
        const success = await login({ username, password }, [2]);
        if (success) {
            navigate("/dashboard");
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") handleLogin();
    };

    return (
        <div className="flex flex-col min-h-screen bg-white" onKeyDown={handleKeyPress}>
            {/* Centered Login Card with Animation */}
            <div className="flex flex-1 items-center justify-center px-4">
                <div className="flex flex-col md:flex-row items-center justify-center gap-8 w-full max-w-2xl">
                    {/* Animation on the left for desktop, top for mobile */}
                    <div className="w-[180px] h-[180px] md:w-[220px] md:h-[220px] mb-6 md:mb-0 flex items-center justify-center">
                        <Lottie animationData={posMachineAnimation} loop={true} className="w-full h-full object-contain" />
                    </div>
                    {/* Login Card */}
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 flex flex-col gap-6 justify-center" style={{ minHeight: '400px' }}>
                        <h2 className="text-2xl font-bold text-center" style={{ color: "#0f172a" }}>Log-in to your account</h2>
                        <div className="flex flex-col gap-4 flex-1 justify-center">
                            {/* Email or phone number */}
                            <div className="relative">
                                <input
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Username"
                                    className="peer w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2"
                                    style={{ color: '#111', background: '#f3f4f6', boxShadow: `0 0 0 2px transparent`, caretColor: loginAccent }}
                                    autoComplete="username"
                                    onFocus={e => e.target.style.boxShadow = `0 0 0 2px ${loginAccent}`}
                                    onBlur={e => e.target.style.boxShadow = `0 0 0 2px transparent`}
                                />
                                <span className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: loginAccent }}><FaUser /></span>
                            </div>
                            {/* Password */}
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password"
                                    className="peer w-full pl-10 pr-10 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2"
                                    style={{ color: '#111', background: '#f3f4f6', boxShadow: `0 0 0 2px transparent`, caretColor: loginAccent }}
                                    autoComplete="current-password"
                                    onFocus={e => e.target.style.boxShadow = `0 0 0 2px ${loginAccent}`}
                                    onBlur={e => e.target.style.boxShadow = `0 0 0 2px transparent`}
                                />
                                <span className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: loginAccent }}><FaLock /></span>
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute top-1/2 right-3 -translate-y-1/2 transition"
                                    style={{ color: loginAccent }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                            {/* Log-in button */}
                            <button
                                type="button"
                                onClick={handleLogin}
                                className="w-full py-3 rounded-lg font-semibold text-white transition shadow active:scale-95"
                                style={{ background: loginAccent }}
                            >
                                Log-in
                            </button>
                            {/* Forgot password link */}
                            {/* <button
                                type="button"
                                className="text-xs text-gray-400 hover:underline mt-1 mx-auto w-fit"
                                tabIndex={-1}
                                disabled
                            >
                                Forgot password?
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer*/}
            <Footer
                className="text-xs text-gray-500 py-4"
                noBorder
                noPadding
                showLegalLinks
            />
        </div>
    );
}
